export default class Http {
    constructor() {
        this.TOKEN = '';
        this.defaults = {
            'Content-Type': 'application/json'
        }
        this.headers = {};
    }
    get(url) {
        return myFetch(url, {
            method: 'GET',
            headers: this.getHeaders(),
        })
    }

    post(url, data) {
        return myFetch(url, {
            method: 'POST',
            headers: this.getHeaders(),
            data: data
        })
    }

    put(url, data) {
        return myFetch(url, {
            method: 'PUT',
            headers: this.getHeaders(),
            data: data
        })
    }

    getHeaders() {
        const headers = Object.assign({}, this.defaults);
        if (this.TOKEN) {
            headers['authorization'] = 'Bearer ' + this.TOKEN;
        }
        return headers;
    }
    setToken(token) {
        this.TOKEN = token;
    }

    setHeader(_h) {
        this.headers = Object.assign({}, this.defaults, _h);
    }
}

function myFetch(url, opt) {
    opt.url = url;
    opt.headers = opt.headers || {};
    const contentType = opt.headers['Content-Type'] || opt.headers['content-type'];

    if (contentType && contentType.includes('json')) {
        if (typeof opt.data === 'object') {
            opt.data = JSON.stringify(opt.data);
        }
    }

    return new Promise(function (resolve, reject) {
        if (!opt.success) {
            opt.success = function (xhr, responseText) {
                const output = parseData(responseText);
                resolve(output);
            }
        }
        if (!opt.error) {
            opt.error = function (xhr, responseText) {
                const output = parseData(responseText);
                reject(output);
            }
        }
        ajax(opt);
    })
}

function ajax(opt) {
    var request = new XMLHttpRequest();
    if (typeof opt.withCredentials !== 'undefined') {
        request.withCredentials = opt.withCredentials;
    }
    request.open(opt.method || 'GET', opt.url, true);
    request.onload = function () {
        if (this.status >= 200 && this.status < 400) {
            if (typeof opt.complete == 'function') {
                opt.complete(request, request.responseText);
            }
            if (typeof opt.success == 'function') {
                opt.success(request, request.responseText);
            }
        } else {
            // We reached our target server, but it returned an error
            if (typeof opt.error == 'function') {
                opt.error(request, request.responseText);
            }
        }
    };

    request.onerror = function () {
        if (typeof opt.error == 'function') {
            opt.error(request, opt);
        }
    };

    let keys = Object.keys(opt.headers);
    for (let key of keys) {
        request.setRequestHeader(key, opt.headers[key]);
    }

    if (opt.data) {
        request.send(opt.data);
    } else {
        request.send();
    }
}

function parseData(s) {
    try {
        const json = JSON.parse(s);
        return json;
    } catch (e) { }
    return s;
}

export const instance = new Http();